import { render, staticRenderFns } from "./MessageMediaItem.vue?vue&type=template&id=754a6e9b&scoped=true&"
import script from "./MessageMediaItem.vue?vue&type=script&lang=ts&"
export * from "./MessageMediaItem.vue?vue&type=script&lang=ts&"
import style0 from "./MessageMediaItem.vue?vue&type=style&index=0&id=754a6e9b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754a6e9b",
  null
  
)

export default component.exports